module.exports = __webpack_public_path__ + "static/media/everyday_digital_june23.b108cb7d.webp";